import React from 'react';
import './Footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-section footer-left">
        <div className="footer-name">Mark Gerken</div>
        <div className="footer-social">
          <a href="https://www.instagram.com/markgerken/" target="_blank" rel="noopener noreferrer" aria-label="Mark's Instagram">
            <FontAwesomeIcon icon={faInstagram} />
          </a>
          <a href="https://www.facebook.com/mark.gerken.33" target="_blank" rel="noopener noreferrer" aria-label="Mark's Facebook">
            <FontAwesomeIcon icon={faFacebook} />
          </a>
        </div>
      </div>

      <div className="footer-section footer-middle">
        <img src="/whiteRedLogo.jpg" alt="Apex Campervans Logo" className="footer-logo" />
        <a href="mailto:apexcampervansllc@gmail.com" className="footer-email">
           <FontAwesomeIcon icon={faEnvelope} />
           <span>apexcampervansllc@gmail.com</span>
        </a>
      </div>

      <div className="footer-section footer-right">
        <div className="footer-name">Nikki Finley</div>
        <div className="footer-social">
          <a href="https://www.instagram.com/nikki_fin/" target="_blank" rel="noopener noreferrer" aria-label="Nikki's Instagram">
            <FontAwesomeIcon icon={faInstagram} />
          </a>
          <a href="https://www.facebook.com/nikki.finley.75" target="_blank" rel="noopener noreferrer" aria-label="Nikki's Facebook">
            <FontAwesomeIcon icon={faFacebook} />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;